import { useCallback } from 'react'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import useTicketVariables from '../../../../../../../utils/hooks/pdf/useTicketVariables'


const usePdfRendererStyles = () => {
    const {fontSizes, headerTicketBorder, separations} = useTicketVariables()
    const renderStyles = useCallback((cssConfig?: TwinDictionary) => {
        let myCssConfig = JSON.parse(JSON.stringify(cssConfig || {}))
        if (cssConfig?.marginTicket){
            myCssConfig['marginTop'] = separations[cssConfig?.marginTicket].conversion
        }
        if (cssConfig?.fontSizeTicket){
            myCssConfig['fontSize'] = fontSizes[cssConfig?.fontSizeTicket].conversion
        }
        if (cssConfig?.headerTicketBorder){
            myCssConfig = { ...cssConfig, ...headerTicketBorder[cssConfig?.headerTicketBorder].conversion}
        }
       return myCssConfig
    }, [fontSizes, headerTicketBorder, separations])
    return {renderStyles}
}

export default usePdfRendererStyles